const onListenMap = {};
const onDispatchMap = {};

const debug = false;

export default class EventManager {
	static registerOnListen(eventName, fn) {
		if (!onListenMap[eventName]) {
			onListenMap[eventName] = [];
		}

		onListenMap[eventName].push(fn);
	}

	static unregisterOnListen(eventName, fn) {
		if (!onListenMap[eventName]) {
			onListenMap[eventName] = onListenMap[eventName].filter((f) => f !== fn);
		}
	}

	static registerOnDispatch(eventName, fn) {
		if (!onDispatchMap[eventName]) {
			onDispatchMap[eventName] = [];
		}

		onDispatchMap[eventName].push(fn);
	}

	static unregisterOnDispatch(eventName, fn) {
		if (onDispatchMap[eventName]) {
			onDispatchMap[eventName] = onDispatchMap[eventName].filter((f) => f !== fn);
		}
	}

	static logEvent(source, name, target) {
		if (debug) {
			console.log(`[forman event:${source}]: ${target.tagName} ${name}`);
		}
	}

	static dispatch(target, name, options = { detail: undefined, bubbles: false, cancelable: false }) {
		this.logEvent('dispatch', name, target);
		if (target && name) {
			const event = new CustomEvent(name, {
				bubbles: options.bubbles,
				cancelable: options.cancelable,
				detail: options.detail,
			});

			if (onDispatchMap[name]?.length) {
				onDispatchMap[name].forEach((m) => {
					m(event, target);
				});
			}

			if (!event.defaultPrevented) {
				return target.dispatchEvent(event);
			}
		}
	}

	static addListener(target, name, fn) {
		target.addEventListener(name, (event) => {
			this.logEvent('listener', name, target);
			this._callOnListens(name, event);

			if (!event.defaultPrevented) {
				fn(event);
			}
		});
	}

	static addNamedNativeListener(target, name, eventName, fn) {
		target.addEventListener(eventName, (event) => {
			this.logEvent('listener', name, target);
			this._callOnListens(name, event);

			if (!event.defaultPrevented) {
				fn(event);
			}
		});
	}

	static _callOnListens(name, event) {
		if (onListenMap[name]?.length > 0) {
			onListenMap[name].some((fn) => fn && fn(event));
		}
	}
}
